import { render, staticRenderFns } from "./WpHistoryInternalCommentBlock.vue?vue&type=template&id=64cf3e0d&"
import script from "./WpHistoryInternalCommentBlock.vue?vue&type=script&lang=js&"
export * from "./WpHistoryInternalCommentBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64cf3e0d')) {
      api.createRecord('64cf3e0d', component.options)
    } else {
      api.reload('64cf3e0d', component.options)
    }
    module.hot.accept("./WpHistoryInternalCommentBlock.vue?vue&type=template&id=64cf3e0d&", function () {
      api.rerender('64cf3e0d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/workPermits/WpHistoryInternalCommentBlock.vue"
export default component.exports